(() => {
  'use strict';
  if (customElements.get('predictive-search')) return;
  const root = window.Shopify?.routes?.root || '/';

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-predictive-search-input]');
      this.results = this.querySelector('[data-predictive-search-results]');
      this.abortController = null;
      this.timer = null;
    }

    connectedCallback() {
      this.input?.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.search(this.input.value.trim()), 180);
      });
      this.input?.addEventListener('keydown', (event) => this.onKeydown(event));
    }

    async search(term) {
      if (!this.results) return;
      if (term.length < 2) {
        this.results.innerHTML = '';
        this.input.setAttribute('aria-expanded', 'false');
        return;
      }
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.classList.add('is-loading');
      try {
        const url = `${root}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection,page,article&resources[limit]=6&section_id=predictive-search`;
        const response = await fetch(url, { signal: this.abortController.signal });
        if (!response.ok) throw new Error('Recherche indisponible');
        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const result = documentFragment.querySelector('#shopify-section-predictive-search') || documentFragment.querySelector('.predictive-results');
        this.results.innerHTML = result?.innerHTML || '';
        this.input.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (error.name !== 'AbortError') this.results.innerHTML = '<p class="predictive-results__empty">Recherche indisponible.</p>';
      } finally {
        this.classList.remove('is-loading');
      }
    }

    onKeydown(event) {
      const links = [...this.results.querySelectorAll('a')];
      if (!links.length || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
      event.preventDefault();
      const current = links.indexOf(document.activeElement);
      const next = event.key === 'ArrowDown' ? Math.min(links.length - 1, current + 1) : Math.max(0, current - 1);
      links[next]?.focus();
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
})();
